// extracted by mini-css-extract-plugin
export default {"container":"iq-z","brandName":"jq-z","productName":"kq-z","productNamePdpEnhancements":"lq-z","breakLongProductName":"mq-z"};